// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__Zo8IS","info":"Panel_info__YA7Wq","btns":"Panel_btns__0aEcz","button":"Panel_button__2xQNq"};